import { set } from "lodash";
import React, { use, useEffect, useState } from "react";
import Select from "react-select";
import { request } from "../../utils/request";
import { formatCurrency, toast } from "../../utils/helpers";

const ItemCompra = ({item, index, impuestos, grupos, tipo, almacen, removeItem, updateTotal, isCreate}) => {
    const [cantidad, setCantidad] = useState(1);
    const [costo, setCosto] = useState(0);
    const [impuesto, setImpuesto] = useState(0);
    const [referencia, setReferencia] = useState(null);
    const [impuesto_id, setImpuesto_id] = useState(null);
    const [grupo, setGrupo] = useState(null);
    const [enableTotalInput, setEnableTotalInput] = useState(true);
    const [total, setTotal] = useState(0);
    const [ignoreTotals, setIgnoreTotals] = useState(false);

    const [items, setItems] = useState([]);

    const getItems = async () => {
        const table = await request('items');

        if (table.data) {
            setItems(table.data);
        }
    };

    const onChangeInput = async (name, value) => {
        switch (name) {
            case "cantidad":
                setCantidad(value);
                break;
            case "costo":
                setCosto(value);
                break;
            case "impuesto":
                setImpuesto(value);
                break;
            case "referencia":
                setReferencia(value);
                break;
            case "impuesto_id":
                setImpuesto_id(value);
                break;
            case "grupo":
                setGrupo(value);
                break;
            case "enableTotalInput":
                setEnableTotalInput(value);
                break;
            // case "total":
            //     setTotal(value);
                break;
            default:
                break;
        }

		// if (enableTotalInput && name !== "costo") {
        //     calcularCosto();
        //     return;
        // } else 
            if (enableTotalInput && name === "costo"){
            setEnableTotalInput(false);
        }
		// actualizarTotal();
	};

    const onChangeImpuesto = async (value) => {
        const impuesto = impuestos.filter((i) => i.id === value)[0];

        setImpuesto_id(impuesto.id);
        setImpuesto(impuesto.porcentaje || 0);

        if (enableTotalInput) {
            calcularCosto();
            return;
        };

        // actualizarTotal();
    };

    const calcularTotal = (costo, cantidad, impuesto) => {
        const p = impuesto < 1 ? impuesto : impuesto / 100;
        return (costo * parseFloat(cantidad)) + (costo * p * parseFloat(cantidad));
    };

    const calcularImpuesto = (costo, cantidad, impuesto) => {
        const p = impuesto < 1 ? impuesto : impuesto / 100;
        return costo * p * cantidad;
    }

    useEffect(() => {
        let imp = impuestos.filter((i) => i.id === impuesto_id)[0];

        if (!imp && item.impuesto) {
            imp = item.impuesto;
        }

        if (parseFloat(cantidad) < 0.01 || cantidad === "") {
            toast("Cantidad no puede ser 0", "error");
        }

        const total = calcularTotal(costo, cantidad, impuesto);
        updateTotal(
            item.id,
            total,
            {
                nombre: imp?.nombre,
                totalImpuesto: calcularImpuesto(costo, cantidad, impuesto),
            }, 0, ignoreTotals
        );

        if(!ignoreTotals) setTotal(total);
        setIgnoreTotals(false);
    }, [cantidad, costo, impuesto, impuesto_id]);
    
    const onChangeTotal = (value) => {
        setIgnoreTotals(true);
        setTotal(value);

        const precio = value / cantidad;
        const imp = parseFloat(impuesto) < 1 ? parseFloat(impuesto) : parseFloat(impuesto) / 100;
        const costo = parseFloat(precio / (1 + imp));
        setCosto(costo);
    };
        
    const onChangeItem = async (itemId) => {
        const itemCompra = items.filter(
            (item) => item.id === itemId
        )[0] ?? {};

        // setId(itemCompra.id ? itemCompra.id : null);
        // setNombre(itemCompra.nombre ? itemCompra.nombre : null);
        // setViejoCosto(itemCompra.costo ?? 0);
        setCosto(0);
        setTotal(itemCompra.total ?? 0);
        setCantidad(1);
        setReferencia(itemCompra.referencia || "");
        setImpuesto(itemCompra.impuesto?.porcentaje || 0);
        setImpuesto_id(itemCompra.impuesto ? itemCompra.impuesto.id : 0);
        setGrupo(itemCompra.grupo?.nombre);
        setEnableTotalInput(true);

        updateTotal(
            item.id,
            calcularTotal(
                itemCompra.costo,
                itemCompra.cantidad,
                itemCompra.impuesto
            )
        );
        // actualizarTotal();
    };
        
    const toggleEnableTotalInput = () => {
        setEnableTotalInput(!enableTotalInput);
    };
    
    const calcularCosto = async (ignoreTotals=false) => {
        const porcentajeImpuesto = impuesto < 1 ? parseFloat(impuesto) : parseFloat(impuesto) / 100;

        setCosto(((parseFloat(total) / (porcentajeImpuesto + 1))/cantidad));

        // actualizarTotal(ignoreTotals);
    }

    useEffect(() => {
        getItems();
    }, []);

    useEffect(() => {
        if (item) {
            setCosto(item.costo);
            setTotal(item.total || 0);
            setCantidad(item.cantidad);
            setReferencia(item.referencia);
            setImpuesto(item.impuesto?.porcentaje * 100 || 0);
            setImpuesto_id(item.impuesto?.id || 0);
            setGrupo(item.grupo?.id);

            if (enableTotalInput) {
                calcularCosto(true);
            } else {
                updateTotal(
                    item.id,
                    calcularTotal(
                        item.costo,
                        item.cantidad,
                        item.impuesto?.porcentaje * 100 || 0
                    ),
                    {
                        nombre: item?.impuesto?.nombre,
                        totalImpuesto: calcularImpuesto(
                            item.costo,
                            item.cantidad,
                            item.impuesto?.porcentaje * 100 || 0
                        ),
                    }, 0, true
                );
            }
		}
    }, []);

    const imp = impuesto_id ? impuestos.filter(i => i.id === impuesto_id)[0] : impuestos[0];

    return <tr>
        <td className="text-center">{index + 1}</td>
        <td>
            <input
                type="hidden"
                name={`compra[items_compra][i${index}][almacen_id]`}
                value={almacen || ""}
            />
            <input type="hidden" name={`compra[items_compra][i${index}][tipo]`} value={item.tipo ?? 'item'} />
            <div>
                <Select
                    key={`i${index}-item_id`}
                    options={items?.map((i) => ({
                        value: i.id,
                        label: `${
                            i.referencia?.padEnd(8, " ") || "N/A"
                        } - ${i.nombre}`,
                    }))}
                    isLoading={!items.length}
                    loadingMessage={() => "Cargando items..."}
                    defaultValue={
                        item?.nombre && {
                            label: item.nombre,
                            value: item.item_id,
                        }
                    }
                    required
                    onChange={(e) => {
                        onChangeItem(e?.value);
                    }}
                    name={`compra[items_compra][i${index}][item_id]`}
                    isClearable={true}
                />
            </div>
        </td>
        <td>
            <input
                type="text"
                key="referencia"
                name={`compra[items_compra][i${index}][referencia]`}
                value={referencia || ""}
                onChange={(e) => {
                    onChangeInput("referencia", e.target.value);
                }}
                /* disabled={compra.item?.referencia} */
                className="form-control"
            />
        </td>
        <td>
            <input
                type="number"
                name={`compra[items_compra][i${index}][cantidad]`}
                value={cantidad}
                min="0.01"
                onChange={(e) =>
                    onChangeInput("cantidad", e.target.value)
                }
                className="form-control text-right"
                step="any"
            />
        </td>
        <td className="text-center"
            title="Doble Click para editar"
            onDoubleClick={() => toggleEnableTotalInput()}
            >
            {!enableTotalInput ? (
            <div className="input-group">
                <div className="input-group-prepend">
                    <span
                        className="input-group-text"
                        id="basic-addon1"
                    >
                        RD$
                    </span>
                </div>
                <input
                    type="number"
                    value={enableTotalInput ? parseFloat(costo).toFixed(2) : costo}
                    onChange={(e) =>
                        onChangeInput("costo", e.target.value)
                    }
                    className="form-control text-right"
                    step="any"
                />
            </div>) : (
                <div className="m-t-5">
                    {formatCurrency(parseFloat(costo).toFixed(2))} <i className="fa fa-pen table-edit-field color-primary"></i>
                </div>
            )}
            <input
                type="hidden"
                name={`compra[items_compra][i${index}][costo]`}
                value={costo || 0}
            />
        </td>
        <td className="text-center">
            <Select
                key={`i${index}-impuesto_id`}
                options={impuestos.map((i) => ({
                    label: i.nombre,
                    value: i.id,
                }))}
                value={imp && {
                    label: imp?.nombre,
                    value: imp?.id,
                }}
                onChange={(e) => onChangeImpuesto(e.value)}
            />
            <input
                type="hidden"
                name={`compra[items_compra][i${index}][impuesto_id]`}
                value={impuesto_id || ""}
            />
        </td>
        <td>
            <div>
                <Select
                    options={grupos?.map((i) => ({
                        value: i.nombre,
                        label: i.nombre,
                    }))}
                    loadingMessage={() => "Cargando..."}
                    value={
                        item?.grupo
                            ? {
                                    label: item.grupo,
                                    value: item.grupo,
                                }
                            : { label: grupo, value: grupo }
                    }
                    required
                    onChange={(e) => {
                        onChangeInput("grupo", e?.value);
                    }}
                    name={`compra[items_compra][i${index}][grupo_id]`}
                    isClearable={true}
                />
            </div>
        </td>
        <td
            className="text-right"
            onDoubleClick={() => toggleEnableTotalInput()}
            title="Doble Click para editar"
        >
            {enableTotalInput ? (
                <div className="input-group">
                    <div className="input-group-prepend">
                        <span
                            className="input-group-text"
                            id="basic-addon1"
                        >
                            RD$
                        </span>
                    </div>
                    <input
                        type="number"
                        value={total || 0}
                        onChange={(e) =>
                            onChangeTotal(e.target.value)
                        }
                        className="form-control text-right"
                        step="any"
                    />
                </div>
            ) : (
                <div className="m-t-5">
                    {formatCurrency(total)} <i className="fa fa-pen table-edit-field color-primary"></i>
                </div>
            )}
            <input
                type="hidden"
                name={`compra[items_compra][i${index}][total]`}
                value={total || 0}
            />
        </td>
        <td>
            <button
                type="button"
                className="btn"
                onClick={() => removeItem(item.id)}
            >
                <i className="fas fa-trash"></i>
            </button>
        </td>
    </tr>;
};

export default ItemCompra;